import { render, staticRenderFns } from "./ResponseTime.vue?vue&type=template&id=55e1e87c&"
import script from "./ResponseTime.vue?vue&type=script&lang=js&"
export * from "./ResponseTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports